import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Spinner, Alert } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import Pagination from './Pagination';

const ModerationLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useUser();
  const [totalPages, setTotalPages] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const [currentPage, setCurrentPage] = useState(parseInt(params.get('page'), 10) || 1);

  useEffect(() => {
    setCurrentPage(parseInt(params.get('page'), 10) || 1);
  }, [location]);

  useEffect(() => {
    setLoading(true);
    // Fetch the moderation logs from the server with pagination
    axios.get(`/api/moderation/moderation-log.php?page=${currentPage}`)
      .then(response => {
        setLogs(response.data.logs);
        setTotalPages(response.data.totalPages);
        setLoading(false);
      })
      .catch(error => {
        setError('Error fetching moderation logs');
        setLoading(false);
      });
  }, [currentPage]);

  const handleUndo = (log) => {
    if (window.confirm(`Are you sure you want to undo this action: ${log.type} (ID: ${log.cardid})?`)) {
      axios.post('/api/moderation/undo-moderation.php', { logId: log.id })
        .then(response => {
          if (response.data.success) {
            alert('Action undone successfully');
            setLogs(prevLogs => prevLogs.filter(l => l.id !== log.id));
          } else {
            alert('Failed to undo action');
          }
        })
        .catch(error => {
          alert('Error undoing action');
          console.error('Error undoing action:', error);
        });
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/moderation-log?page=${page}`);
  };

  if (!user || user.mod !== true) {
    return <p>You can't access this page.</p>;
  }

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="mt-5">
        {error}
      </Alert>
    );
  }

  return (
    <div className="container mt-5 position-relative z-2">
      <h2>Moderation Log</h2>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Type</th>
            <th>Reason</th>
            <th>Moderator</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log.id}>
              <td>
              {log.type === 'card' ? (
                  <Link to={`/gallery/?selectedCard=${log.cardid}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {log.type} {log.cardid}
                  </Link>
                ) : log.type === 'user' ? (
                  <Link to={`/gallery/user/${log.cardid}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {log.type} {log.cardid}
                  </Link>
                ) : (
                  `${log.type} ${log.cardid}`
                )}
              </td>
              <td>{log.reason}</td>
              <td>
                <Link to={`/gallery/user/${log.userid}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  {log.username}
                </Link>
              </td>
              <td>{new Date(log.date * 1000).toLocaleString()}</td>
              <td>
                <Button 
                  variant="warning" 
                  onClick={() => handleUndo(log)}
                >
                  Undo
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default ModerationLog;